export default __webpack_public_path__ + "static/media/mezzoSlide.e4ea2f31.svg";